import React, { Component } from 'react'

export default class MoreOn extends Component {
  render() {
    return (
      <div className='more-on-ableton'>
        <span>More on Ableton.com:</span>
        <ul>
            <li><a href='#'>Blog</a></li>
            <li><a href='#'>Ableton for the Classroom</a></li>
            <li><a href='#'>Ableton for Colleges and Universities</a></li>
            <li><a href='#'>Certifies Training</a></li>
            <li><a href='#'>About Ableton</a></li>
            <li><a href='#'>Jobs</a></li>
            <li><a href='#'>Apprenticeships</a></li>
        </ul>
      </div>
    )
  }
}
